export enum Keys {
  Enter = 'Enter',
  Tab = 'Tab',
  Space = ' ',
  IESpace = 'Spacebar',
  Coma = ',',
  Semicolon = ';',
  Backspace = 'Backspace',
}

export enum ControlStatus {
  Pending = 'PENDING',
  Valid = 'VALID',
  Invalid = 'INVALID'
}
